module.exports = __webpack_public_path__ + "img/logo-template.ad27b343.svg";